// Fuente única de verdad para el color/tier del opportunity score.
// Usado por las cards de la lista (OpportunityBadge), los markers del mapa
// (PropertyMarkers) y la leyenda dual (MapView). Mantener sincronizado con
// las clases `.opp-*` en styles.css.

export type OppTier = 'great' | 'good' | 'mid' | 'low';

/** Umbrales alineados con OpportunityBadge: ≥75 great, ≥60 good, ≥45 mid. */
export function oppTier(score: number): OppTier {
  const r = Math.round(score);
  if (r >= 75) return 'great';
  if (r >= 60) return 'good';
  if (r >= 45) return 'mid';
  return 'low';
}

const TIER_COLORS: Record<OppTier, string> = {
  great: '#16a34a',
  good: '#84cc16',
  mid: '#f59e0b',
  low: '#71717a',
};

/** Color de relleno del marker; slate apagado cuando no hay score computado. */
export function oppColor(score: number | null | undefined): string {
  if (score === null || score === undefined) return '#475569';
  return TIER_COLORS[oppTier(score)];
}

/**
 * Etiqueta corta para leyenda/tooltips: sólo el rango numérico. Sin
 * adjetivos («Excelente», «Buena»…) desde el 2026-10-08: el score describe,
 * no califica.
 */
export const OPP_TIER_LABELS: Array<{ tier: OppTier | 'none'; label: string; color: string }> = [
  { tier: 'great', label: '75–100', color: TIER_COLORS.great },
  { tier: 'good', label: '60–74', color: TIER_COLORS.good },
  { tier: 'mid', label: '45–59', color: TIER_COLORS.mid },
  { tier: 'low', label: 'Menos de 45', color: TIER_COLORS.low },
  { tier: 'none', label: 'Sin score', color: '#475569' },
];
